export const Routes = {
    SCT: { path: "/" },
    Configuration: { path: "/configuration" },
    Signin: { path: "/login" },
    ForgotPassword: { path: "/forgot-password" },
    NotFound: { path: "/404" },
};